/* eslint-disable camelcase */

module.exports = function (self) {
	return {
		async add({ name, slug, type, description }) {
			try {
				// category, hashtag, store, brand
				const response = await self.$http.put('admin/tags', {
					name,
					slug,
					type,
					description,
				}, {
					headers: {
						Authorization: true,
					},
				});

				self.resetStatus();

				return {
					ok: true,
					tag: response.data.tag[0],
				};
			} catch (error) {
				self.resetStatus();

				return {
					ok: false,
					tag: null,
				};
			}
		},
		async edit({ id, name, slug, type, description }) {
			try {
				// category, hashtag, store, brand
				await self.$http.patch('admin/tags', {
					id,
					name,
					slug,
					type,
					description,
				}, {
					headers: {
						Authorization: true,
					},
				});

				self.resetStatus();
				return true;
			} catch (error) {
				self.resetStatus();

				return false;
			}
		},
		async delete(id) {
			try {
				await self.$http.delete('admin/tags', {
					data: {
						id,
					},
					headers: {
						Authorization: true,
					},
				});

				self.resetStatus();

				return true;
			} catch (error) {
				self.resetStatus();
				return false;
			}
		},
	};
};
